{
  "GARAGE": {
    "DATABASE": {
      "ERROR": "Datenbankfehler aufgetreten."
    },
    "ORDER": {
      "NOT_FOUND": "Auftrag nicht gefunden.",
      "CREATE_ERROR": "Fehler beim Erstellen des Auftrags.",
      "INPUT_ERROR": "Fehler: Auftrag oder Kunde ist null.",
      "ID_MISMATCH": "ID im Auftrag und Header stimmt nicht überein.",
      "OBJECT_ID_MUST_BE_NULL": "Objekt-ID muss leer sein.",
      "OBJECT_ID_MISMATCH": "Objekt-ID stimmt nicht überein.",
      "OBJECT_NOT_ALLOWED": "Operation nicht erlaubt.",
      "INTERNAL_CUSTOMER_REQUIRES_INTERNAL_SELLING_TYPE": "Internkunde nur mit interner Verkaufsart möglich.",
      "CLOSE": {
        "STOCK_POSTING_NOT_SUPPORTED": "Abschluss Eigenverbrauch nicht unterstützt."
      }
    },
    "ORDER_ITEM": {
      "ITEMS_EMPTY": "Keine Auftragspositionen vorhanden.",
      "NO_ORDER": "Kein Auftrag gefunden.",
      "NO_PRODUCT": "Kein Artikel vorhanden.",
      "NULL_MODEL": "Auftragsposition ist null.",
      "NO_ORDER_FOR_PRICE": "Kein Auftrag - Preis kann nicht berechnet werden.",
      "ORDER_NOT_FOUND_BY_ID": "Auftrag mit ID {{orderId}} nicht gefunden.",
      "PRODUCT_NOT_FOUND_BY_ID": "Artikel (Artstamm) mit ID {{productId}} nicht gefunden."
    },
    "TASK": {
      "TYPE_ONLY_UNPRODUCTIVE": "Nur unproduktive Tätigkeiten werden unterstützt.",
      "TYPE_ONLY_ORDER": "Nur Auftragsaufgaben werden unterstützt.",
      "ORDER_ALREADY_CLOSED": "Auftrag ist bereits abgeschlossen.",
      "ACTIVITY_NOT_FOUND": "Tätigkeit existiert nicht."
    },
    "TIME_REPORT": {
      "DATE_VALUES_NULL": "Datumswerte sind null.",
      "NO_TYPE": "Keine Zeitbewegungsart für Arbeitsbericht gefunden.",
      "MULTIPLE_RUNNING": "Mehr als ein Arbeitsbericht läuft für Benutzer: {{user}}.",
      "NONE_RUNNING": "Kein laufender Arbeitsbericht für Benutzer: {{user}}."
    },
    "TIMEREPORT": {
      "MULTIPLE_RUNNING": "Es laufen zwei Arbeitsberichte für diesen Mitarbeiter.",
      "NONE_RUNNING": "Kein gestarteter Arbeitsbericht zu diesem Mitarbeiter."
    },
    "VEHICLE": {
      "NOT_FOUND": "Fahrzeug nicht gefunden.",
      "NAME_MUST_BE_EMPTY_FOR_TOOL": "Name muss bei Kleingerät-Erstellung leer sein.",
      "ID_MISMATCH": "IDs stimmen nicht überein.",
      "NOT_FOUND_BY_ID": "Kein Fahrzeug mit ID {{vehicleId}} gefunden."
    },
    "OBJECT": {
      "NOT_FOUND": "Kein Objekt gefunden."
    },
    "COMPANY": {
      "GARAGE_CONFIG_NOT_FOUND": "Firmawerkstatt nicht gefunden."
    },
    "PRINT": {
      "PDF_NOT_FOUND": "Keine PDF-Daten gefunden.",
      "PDF_MORE_THAN_ONE": "Mehr als ein PDF ist hier nicht erlaubt.",
      "INVOICE_PREVIEW_NOT_FOUND": "Kein Vorschaubeleg zum Objekt vorhanden."
    },
    "MECHANIC": {
      "NOT_FOUND": "Benutzer ist kein Mechaniker."
    },
    "EMPLOYEE": {
      "NOT_REGISTERED": "Benutzer: {{name}} ist nicht im Personalstamm (Firma: {{company}}) angelegt."
    }
  }
}
